export const RESET_NOTIFICATIONS = '[Notifications] reset';
export const ADD_NOTIFICATION = '[Notifications] add';
export const DISPOSE_NOTIFICATION = '[Notifications] dispose';
